module.exports = __webpack_public_path__ + "static/media/ice_wizard_hood.7b53a666.png";